// Shared domain types for frontend
export type PatientStatus = 'New' | 'Active' | 'Inactive' | 'Archived' | 'Responsible';

export interface PatientNameParts {
  firstName: string;
  secondName?: string;
  firstLastName: string;
  secondLastName?: string;
  presentedName?: string; // optional override shown to users
}

export interface PatientBasic extends PatientNameParts {
  id: number;
  hc?: string; // Historia Clínica (clinical history number)
  email?: string;
  dateOfBirth?: string;
  nextContact?: string; // ISO yyyy-MM-dd from backend
  phoneNumber?: string;
  address?: string;
  status: PatientStatus;
  statusName?: string; // human-readable from backend (fallback to status enum)
  notes?: string;
  profilePicturePath?: string; // backend relative path
  referralSource?: string;
  responsiblePartyId?: number | null;
  balanceDue?: number;
}

export interface PatientListItem extends PatientBasic {
  // compatibility field for existing components expecting single name
  name: string; // derived from presentedName || firstName + firstLastName
}

// Utility to derive display name
export const buildDisplayName = (p: Partial<PatientNameParts>) => {
  if (p.presentedName && p.presentedName.trim().length) return p.presentedName.trim();
  const segs = [p.firstName, p.secondName, p.firstLastName, p.secondLastName].filter(Boolean);
  return segs.join(' ');
};
